export enum DetailProperties {
  category = '育樂類別',
  description = '類別介紹',
}
